<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header
        :header-title="$t('INBOX_MGMT.DISABLE.TITLE')"
        :header-content="description"
      />
      <form class="w-full" @submit.prevent="onDisable">
        <label class="input-wrap">
          {{ $t('INBOX_MGMT.DISABLE.FORM.REASON.LABEL') }}
        </label>
        <textarea
          v-model="disableReason"
          rows="4"
          class="w-full resize-none"
          :class="{ error: showError }"
          :placeholder="$t('INBOX_MGMT.DISABLE.FORM.REASON.PLACEHOLDER')"
        />
        <p v-if="showError" class="error message">
          {{ $t('INBOX_MGMT.DISABLE.FORM.REASON.ERROR') }}
        </p>
        <div class="modal-footer">
          <!-- woot-button defaults to type="submit": the submit button must not
               also bind @click (it would fire onDisable twice), and cancel must
               .prevent or it submits the form too. Same shape as
               ConfirmDeleteModal. -->
          <woot-button variant="clear" @click.prevent="onCancel">
            {{ $t('INBOX_MGMT.DISABLE.FORM.CANCEL') }}
          </woot-button>
          <woot-button
            variant="smooth"
            color-scheme="warning"
            :is-disabled="!disableReason.trim() || uiFlags.isDisabling"
            :is-loading="uiFlags.isDisabling"
          >
            {{ $t('INBOX_MGMT.DISABLE.FORM.SUBMIT') }}
          </woot-button>
        </div>
      </form>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { INBOX_TYPES } from 'shared/mixins/inboxMixin';

export default {
  mixins: [alertMixin],
  props: {
    inbox: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disableReason: '',
      showError: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
    // disabling is offered for every channel type, but only WhatsApp has a
    // globally unique phone number to release -- promising that on a website or
    // email inbox would be a lie
    description() {
      const desc = this.$t('INBOX_MGMT.DISABLE.DESC', {
        inboxName: this.inbox.name,
      });
      if (this.inbox.channel_type !== INBOX_TYPES.WHATSAPP) return desc;
      return `${desc} ${this.$t('INBOX_MGMT.DISABLE.DESC_PHONE_NUMBER')}`;
    },
  },
  methods: {
    async onDisable() {
      if (!this.disableReason.trim()) {
        this.showError = true;
        return;
      }
      try {
        await this.$store.dispatch('inboxes/disable', {
          inboxId: this.inbox.id,
          disableReason: this.disableReason.trim(),
        });
        this.showAlert(this.$t('INBOX_MGMT.DISABLE.FORM.SUCCESS_MESSAGE'));
        this.$emit('disabled');
      } catch (error) {
        this.showAlert(
          error?.response?.data?.message ||
            this.$t('INBOX_MGMT.DISABLE.FORM.ERROR_MESSAGE')
        );
      }
    },
    onCancel() {
      this.disableReason = '';
      this.showError = false;
      this.$emit('cancel');
    },
  },
};
</script>
